<template>
    <div class="cls-footers">
        <div class="cls-footer-content">
            <div class="fd-footer-contact-wrapper">
                <p class="cls-footer-contact">
                    Contact Us
                </p>
                <p class="cls-footer-contact-text">
                    Address：NO.1 Beichen West Road, Chaoyang District, Beijing Institute of Microbiology, Chinese Academy of
                    Sciences

                </p>
                <p class="cls-footer-contact-text">
                    Email：gcmeta_admin@wdcm.org</p>
            </div>
            <ul class="fd-visit-con" v-if="visitInfo.year">
                <li>
                    <span>{{visitInfo.year}} Visits</span>
                    <h4>{{toThousands(visitInfo.visits)}}</h4>
                    <img src="../../images/common/visit.png" alt="">
                </li>
                <li>
                    <span>{{visitInfo.year}} Visitor Countries</span>
                    <h4>{{toThousands(visitInfo.visitsCountryNum)}}</h4>
                    <img src="../../images/common/country.png" alt="">
                </li>
            </ul>
            <div id="_ideConac">
            </div>
        </div>
        <div class="copyright">
            <!-- Copyright：National Microbiology Data Center | Filing Info：京ICP备06066622号-32 | 京公网安备
            11010502044270号 -->

            <div class="fd-footer-icp">
                <div class="fd-footer-icp-content">
                    Copyright：National Microbiology Data Center | Filing Info：
                    <p>京ICP备06066622号-32 | &nbsp;</p>
                    <img src="../../images/common/jgwbimcas.png"> &nbsp;
                    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502044270">
                        京公网安备11010502044270号
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'Footer',
  data () {
    return {
      visitInfo: {
        year: null,
        visits: 0,
        visitsCountryNum: 0
      }
    };
  },
  created () {
    this.getVisitInfo();
  },
  methods: {
    toThousands  (num) {
      num = Number(num);
      let result = [], counter = 0;
      num = (num || 0).toString().split('');
      for (let i = num.length - 1; i >= 0; i--) {
        counter++;
        result.unshift(num[i]);
        if (!(counter % 3) && i != 0) { result.unshift(','); }
      }
      return result.join('');
    },
    getVisitInfo () {
      this.Ajax(API.VisitsNumber, {}, 'get', false).then((res) => {
        if (res) {
          this.visitInfo.visitsCountryNum = res.visitsCountryNum;
          if (res.visitsNumber) {
            this.visitInfo.year = res.visitsNumber.year;
          }
          if (res.visitsNumber && res.visitsNumber.yeartotal) {
            this.visitInfo.visits = res.visitsNumber.yeartotal.visits;
          }
        }
      });
    },
    // 引入事业单位图标
    loadScript (src, callback) {
      // 创建script标签
      var script = document.createElement('script'),
        head = document.getElementsByTagName('head')[0];
      script.type = 'text/javascript';
      script.charset = 'UTF-8';
      script.src = src;
      // 兼容性
      if (script.addEventListener) {
        script.addEventListener(
          'load',
          function () {
            callback();
          },
          false
        );
      } else if (script.attachEvent) {
        script.attachEvent('onreadystatechange', function () {
          var target = window.event.srcElement;
          if (target.readyState == 'loaded') {
            callback();
          }
        });
      }
      head.appendChild(script);
    }
  },
  mounted () {
    setTimeout(() => {
      this.loadScript(
        'https://dcs.conac.cn/js/33/000/0000/60426997/CA330000000604269970040.js',
        () => {}
      );
    }, 100);
  }
};
</script>
<style lang="less">
.cls-footers {
    height: 178px;
    position: relative;
    z-index: 100;
    background: #0E1C29;

    .cls-footer-content {
        width: 1200px;
        margin: 0 auto;
        padding-top: 26px;
        margin-bottom: 34px;
        position: relative;
        display: flex;
        justify-content: space-between;
        .fd-footer-contact-wrapper {
            max-width: 500px;
        }
        .fd-visit-con {
            display: flex;
            width: fit-content;
            >li {
                position: relative;
                min-width: 270px;
                height: 90px;
                background: linear-gradient( 136deg, rgba(255,255,255,0.03) 0%, rgba(255,255,255,0.04) 100%);
                border-radius: 4px;
                border: 1px solid rgba(255,255,255,0.12);
                box-sizing: border-box;
                padding: 16px;
                >span {
                    color: #9EA2A5;
                }
                >h4 {
                    color: #fff;
                    margin-top: 16px;
                    font-size: 20px;
                }
                >img {
                    display: block;
                    height: 56px;
                    position: absolute;
                    top: 18px;
                    right: 20px;
                }
            }
            >li:nth-child(1) {
                margin-right: 24px;
            }
        }
        .cls-footer-contact {
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #fff;
            font-size: 16px;
            margin-bottom: 22px;
        }

        .cls-footer-contact-text {
            color: #9EA2A5;
            margin-bottom: 15px;
            line-height: 16px;
            a {
                color: #9EA2A5;
                text-decoration: none;
            }
        }

        /* #_ideConac {
            position: absolute;
            right: 6px;
            top: 25px;
            cursor: pointer;
        } */

        .logo {
            position: absolute;
            top: 26px;
            right: 5px;
        }

    }

    .copyright {
        width: 100%;
        height: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #767D83;
        line-height: 39px;
        margin: auto;
        background: #011220;
        text-align: center;

        .fd-footer-icp-content {
            width: 1200px;
            margin: 0 auto;
            text-align: center;
            display: flex;
            color: #767d83;
            height: 40px;
            align-items: center;
            justify-content: center;

            a {
                color: #767d83;
                text-decoration: none;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/footers.vue